angular
	.module 'App.Directive'
	.directive 'configVisible', ['ConfigurationService', '$rootScope', (ConfigurationService, $rootScope) ->
		restrict: 'A'
		link: (scope, elem, attrs) ->
			triggerRelink = ->
				# Treat empty config as no config at all and default-visible
				if attrs.configVisible == 'true' || attrs.configVisible == ''
					isVisible = true
				else if attrs.configVisible == 'false'
					isVisible = false
				else if attrs.configVisible.indexOf('[') == 0
					# Can't pass array in attrs
					# @see https://stackoverflow.com/questions/20811527/angularjs-pass-newly-created-array-in-attribute-to-directive/32024667
					configs = scope.$eval(attrs.configVisible)

					isVisible = ConfigurationService.isEnabled(configs)
				else
					isVisible = ConfigurationService.isEnabled(attrs.configVisible)

				elem.toggle(isVisible)

			triggerRelink()
			$rootScope.$on 'REFRESH', triggerRelink
	]
	.directive 'configInvisible', ['ConfigurationService', '$rootScope', (ConfigurationService, $rootScope) ->
		restrict: 'A'
		link: (scope, elem, attrs) ->
			triggerRelink = ->
				elem.toggle(!ConfigurationService.isEnabled(attrs.configInvisible))

			triggerRelink()
			$rootScope.$on 'REFRESH', triggerRelink
	]
